import { render, staticRenderFns } from "./AboutProjectHead.vue?vue&type=template&id=18656c12"
import script from "./AboutProjectHead.vue?vue&type=script&lang=ts"
export * from "./AboutProjectHead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports